var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Socket_instances, _Socket_receiveQueue, _Socket_sendQueue, _Socket_closed, _Socket_backend, _Socket_onMessage, _Socket_onClose, _Socket_handleOpen, _Socket_onOpen;
export class Socket {
    get state() {
        return __classPrivateFieldGet(this, _Socket_closed, "f") ? "closed" : "opened";
    }
    set onMessage(value) {
        if (__classPrivateFieldGet(this, _Socket_receiveQueue, "f").length && value) {
            __classPrivateFieldGet(this, _Socket_receiveQueue, "f").forEach(value);
            __classPrivateFieldSet(this, _Socket_receiveQueue, [], "f");
        }
        __classPrivateFieldSet(this, _Socket_onMessage, value, "f");
    }
    set onClose(value) {
        if (this.state == "closed" && value)
            value();
        __classPrivateFieldSet(this, _Socket_onClose, value, "f");
    }
    set onOpen(value) {
        if (this.state == "opened" && value)
            value();
        __classPrivateFieldSet(this, _Socket_onOpen, value, "f");
    }
    constructor(backend, isOpen) {
        _Socket_instances.add(this);
        _Socket_receiveQueue.set(this, []);
        _Socket_sendQueue.set(this, []);
        _Socket_closed.set(this, false);
        _Socket_backend.set(this, void 0);
        _Socket_onMessage.set(this, void 0);
        _Socket_onClose.set(this, void 0);
        _Socket_onOpen.set(this, void 0);
        __classPrivateFieldSet(this, _Socket_backend, backend, "f");
        if (isOpen)
            __classPrivateFieldSet(this, _Socket_sendQueue, undefined, "f");
        __classPrivateFieldGet(this, _Socket_backend, "f").addEventListener("open", () => {
            if (__classPrivateFieldGet(this, _Socket_onOpen, "f"))
                __classPrivateFieldGet(this, _Socket_onOpen, "f").call(this);
            __classPrivateFieldGet(this, _Socket_instances, "m", _Socket_handleOpen).bind(this);
        });
        __classPrivateFieldGet(this, _Socket_backend, "f").addEventListener("message", async (event) => {
            const data = this.processReceived(event.data);
            __classPrivateFieldGet(this, _Socket_instances, "m", _Socket_handleOpen).call(this);
            if (__classPrivateFieldGet(this, _Socket_onMessage, "f"))
                __classPrivateFieldGet(this, _Socket_onMessage, "f").call(this, data);
            else
                __classPrivateFieldGet(this, _Socket_receiveQueue, "f")?.push(data);
        });
        __classPrivateFieldGet(this, _Socket_backend, "f").addEventListener("close", () => {
            if (__classPrivateFieldGet(this, _Socket_onClose, "f"))
                __classPrivateFieldGet(this, _Socket_onClose, "f").call(this);
            __classPrivateFieldSet(this, _Socket_closed, true, "f");
        });
    }
    send(message) {
        if (__classPrivateFieldGet(this, _Socket_sendQueue, "f"))
            __classPrivateFieldGet(this, _Socket_sendQueue, "f").push(this.processSend(message));
        else
            __classPrivateFieldGet(this, _Socket_backend, "f").send(this.processSend(message));
    }
}
_Socket_receiveQueue = new WeakMap(), _Socket_sendQueue = new WeakMap(), _Socket_closed = new WeakMap(), _Socket_backend = new WeakMap(), _Socket_onMessage = new WeakMap(), _Socket_onClose = new WeakMap(), _Socket_onOpen = new WeakMap(), _Socket_instances = new WeakSet(), _Socket_handleOpen = function _Socket_handleOpen() {
    __classPrivateFieldGet(this, _Socket_sendQueue, "f")?.forEach(buffer => __classPrivateFieldGet(this, _Socket_backend, "f").send(buffer));
    __classPrivateFieldSet(this, _Socket_sendQueue, undefined, "f");
};
//# sourceMappingURL=Socket.js.map